'use strict';

var React = require('react');

var SvgMetaobjectMinor = function SvgMetaobjectMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.75a2.75 2.75 0 0 1 2.75-2.75h.25a.75.75 0 0 1 0 1.5h-.25c-.69 0-1.25.56-1.25 1.25v2.25a.75.75 0 0 1-.22.53l-.47.47.47.47c.141.14.22.331.22.53v2.25c0 .69.56 1.25 1.25 1.25h.25a.75.75 0 0 1 0 1.5h-.25a2.75 2.75 0 0 1-2.75-2.75v-1.94l-.78-.78a.75.75 0 0 1 0-1.06l.78-.78v-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13.25a2.75 2.75 0 0 1-2.75 2.75h-.25a.75.75 0 0 1 0-1.5h.25c.69 0 1.25-.56 1.25-1.25v-2.25a.75.75 0 0 1 .22-.53l.47-.47-.47-.47a.75.75 0 0 1-.22-.53v-2.25c0-.69-.56-1.25-1.25-1.25h-.25a.75.75 0 0 1 0-1.5h.25a2.75 2.75 0 0 1 2.75 2.75v1.94l.78.78a.75.75 0 0 1 0 1.06l-.78.78v1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.786 6.056a1.75 1.75 0 0 0-1.572 0l-2.25 1.13a1.75 1.75 0 0 0-.964 1.564v2.5c0 .662.373 1.267.964 1.564l2.25 1.13a1.75 1.75 0 0 0 1.572 0l2.25-1.13a1.75 1.75 0 0 0 .964-1.564v-2.5a1.75 1.75 0 0 0-.964-1.564l-2.25-1.13Zm-.898 1.34a.25.25 0 0 1 .224 0l2.25 1.13a.25.25 0 0 1 .138.224v2.5a.25.25 0 0 1-.138.223l-2.25 1.131a.25.25 0 0 1-.224 0l-2.25-1.13a.25.25 0 0 1-.138-.224v-2.5a.25.25 0 0 1 .138-.223l2.25-1.131Z"
  }));
};
SvgMetaobjectMinor.displayName = "MetaobjectMinor";

exports.SvgMetaobjectMinor = SvgMetaobjectMinor;
